<script setup lang="ts">
import { useReactiveQueryParam } from '@/composables/useReactiveQueryParam'
import { AccountListActionTypes, useAccountListStore } from '@/modules/account/stores/account.list.store.ts'
import AccountDetail from '@/modules/account/views/AccountDetail.vue'
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import FilterList from '@/onenetwork/components/filter/FilterList.vue'
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import _ from 'lodash'
import { computed, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useAccountDetailStore } from '../stores/account.detail.store'


const router = useRouter()
const accountListStore = useAccountListStore()
const accountDetailStore = useAccountDetailStore()

const pageTabs = computed(() => {
  return accountListStore.tabs
})
const displayTabContent = computed(() => {
  return accountListStore.tabs?.find(tab => tab.active)?.id || 'list'
})
const TableConfig = computed(() => {
  return accountListStore.tableConfig
})
const filter = computed(() => {
  return accountListStore.filter
})
const loading = computed(() => {
  return accountListStore.action_type == AccountListActionTypes.FETCHING
})
const page = computed(() => {
  return accountListStore.page
})
const pageSize = computed(() => {
  return accountListStore.pageSize
})

const dataSource = computed(() => accountListStore.data)

const handleChangeTab = (tab: any) => {

  accountListStore.changeTab(tab.id)
}

const handleCloseTab = (tab: any) => {

  accountListStore.closeTab(tab.id)
}

const handleCloseAllTab = () => {
  accountListStore.closeAllTab()
}

const handleChangePage = (page: number) => {

  accountListStore.changePage(page)
}

const handleChangePageSize = (size: number) => {

  accountListStore.changePageSize(size)
}

const handleUpdateFilter = (filter: any) => {

  accountListStore.setFilter(filter)
}

const handleRowDblClick = (e: MouseEvent, item: any) => {

  accountListStore.newTab({id: item.id, label: `#${item.code} - ${item.full_name}`, active: true})
}

const handleRowClick = (e: MouseEvent, item: any) => {

}

const handleChangeSelectedRow = (ids: Array<string|number>) => {

}

const handleSort = (field: string, direction: string) => {

  accountListStore.toggleSort(field, direction)
}

const requestFetchAccountList = _.debounce(async () => {
  try{
    const res = await accountListStore.fetchList();

  } catch (e) {

  }
}, 500)

const detailId: any = useReactiveQueryParam('detailId')
const setDetailTab = async () => {
  if(parseInt(detailId.value || 0)){
    try {
      const data: any = await accountDetailStore.fetchAccountDetail(parseInt(detailId.value))
      accountListStore.newTab({id: data.id, label: `#${data.code} - ${data.full_name}`, active: true})
    } catch (e: any) {

    }
  }
}

watch(()=> accountListStore.uuid, (newVal, oldVal) => {

  requestFetchAccountList()
})

onMounted(() => {
  accountListStore.changeTab('list')
  requestFetchAccountList()
  // if(accountListStore.action_type === AccountListActionTypes.PENDING) requestFetchAccountList()
})

const handleResetFilter = () => {

  accountListStore.resetFilter()
  requestFetchAccountList()
}

watch(()=>detailId, (val) => {

  if(val.value) setDetailTab()
}, {immediate: true})

</script>

<template>
  <dashboard-layout currentRoute="account/list" page-title="Danh sách tài khoản" :tabs="pageTabs" :tabsEvent="{
    close: handleCloseTab,
    select: handleChangeTab,
    closeAll: handleCloseAllTab
  }">
    <template v-if="displayTabContent == 'list'">
      <filter-list
        :filter="filter"
        @update:filter="handleUpdateFilter"
        @reset:filter="handleResetFilter"
      />
      <data-table
        :loading="loading"
        :tableConfig="TableConfig"
        :page-size="pageSize"
        :page="page"
        :total-page="dataSource?.totalPage || 0"
        :total-records="dataSource?.totalRecords || 0"
        :data="dataSource.list || []"
        :row-action-buttons="[
          { action: handleRowDblClick, css: 'btn btn-cs', label: 'Chi tiết', icon: 'iconamoon:edit-duotone', perm: 'account.view_info' }
        ]"
        primaryField=""
        @page-changed="handleChangePage"
        @pagesize-changed="handleChangePageSize"
        @toggle-visibility="accountListStore.toggleColumnVisibility"
        @on-selected-row="handleChangeSelectedRow"
        @on-sort="handleSort"

      />
    </template>
    <template v-else>
      <template v-for="tab in pageTabs">
        <template v-if="tab.id == displayTabContent">
          <AccountDetail :id="tab.id" :key="tab.id" :is-update="true"/>
        </template>
      </template>
    </template>
  </dashboard-layout>
</template>

<style scoped></style>
